module.exports = {
  'en': {
    'HRMS6AEC1': {
      '10': 'Department Code',
      '20': 'Or Emp.Code',
      '30': 'Request Date from',
      '40': 'To',
      '50': 'Emp.Code',
      '60': 'Name',
      '70': 'Req Date',
      '80': 'Seq',
      '90': 'Working Date',
      '100': 'Shift',
      '110': 'Actual Time In - Out',
      '120': 'Shift',
      '130': 'Actual Time In - Out',
      '140': 'Status',
      '150': 'Remarks',
      '160': 'Last Approve By',
      '170': 'Next Step Approval'
    },
    'HRMS6AEC2': {
      '10': 'For Emp.Code',
      '20': 'From Date',
      '30': 'To Date',
      '40': 'Date',
      '50': 'Day',
      '60': 'Shift',
      '70': 'Actual Time In',
      '80': 'Date',
      '90': 'Time',
      '100': 'Actual Time Out',
      '110': 'Date',
      '120': 'Time',
      '130': 'Reason',
      '140': 'Reason',
      '150': 'รายละเอียด',
      '160': 'Abnormal (H:M)',
      '170': 'Late',
      '180': 'Early',
      '190': 'Absence',
      '195': 'Status',
      '200': 'Detail of Time Record'
    },
    'STDATTEN': {
      '0': 'Actual Time in-out',
      '10': 'Actual Time in-out',
      '20': 'Employee Name',
      '30': 'Date',
      '40': 'Day',
      '50': 'Shift',
      '60': 'Schedule Time',
      '70': 'Time In',
      '80': 'Time Out',
      '90': 'Time Stamp',
      '100': 'From',
      '110': 'To',
      '120': 'Customer Code',
      '130': 'Job Code',
      '140': 'Reason Code',
      '150': 'Reason to work',
      '160': 'Detail of work'
    }
  },
  'th': {
    'HRMS6AEC1': {
      '10': 'หน่วยงาน',
      '20': 'หรือ รหัสพนักงาน',
      '30': 'วันที่ขอตั้งแต่',
      '40': 'ถึงวันที่',
      '50': 'รหัสพนักงาน',
      '60': 'ชื่อ-นามสกุล',
      '70': 'วันที่ขอ',
      '80': 'ลำดับที่',
      '90': 'วันที่ทำงาน',
      '100': 'รหัสกะ',
      '110': 'เวลาเข้า-ออกงานจริง',
      '120': 'รหัสกะ',
      '130': 'เวลาเข้า-ออกงานจริง',
      '140': 'สถานะ',
      '150': 'หมายเหตุ',
      '160': 'ผู้อนุมัติล่าสุด',
      '170': 'ผู้อนุมัติลำดับถัดไป'
    },
    'HRMS6AEC2': {
      '10': 'สำหรับพนักงาน',
      '20': 'ตั้งแต่วันที่',
      '30': 'ถึงวันที่',
      '40': 'วันที่',
      '50': 'วัน',
      '60': 'กะ',
      '70': 'เวลารูดบัตรเข้า',
      '80': 'วันที่',
      '90': 'เวลา',
      '100': 'เวลารูดบัตรออก',
      '110': 'วันที่',
      '120': 'เวลา',
      '130': 'รหัสสาเหตุ',
      '140': 'สาเหตุการขอแก้ไข',
      '150': 'รายละเอียด',
      '160': 'ความผิดปกติ(ชม:นาที)',
      '170': 'สาย',
      '180': 'กลับก่อน',
      '190': 'ขาดงาน',
      '195': 'สถานะ',
      '200': 'รายละเอียดการรูดบัตร'
    },
    'STDATTEN': {
      '0': 'รายละเอียดเวลาปฏิบัติงาน',
      '10': 'รายละเอียดเวลาปฏิบัติงาน',
      '20': 'ชื่อพนักงาน',
      '30': 'วันที่',
      '40': 'วัน',
      '50': 'รหัสกะ',
      '60': 'เวลาปฏิบัติงาน',
      '70': 'เวลารูดบัตรเข้า',
      '80': 'เวลารูดบัตรออก',
      '90': 'เวลารูดบัตร',
      '100': 'ตั้งแต่',
      '110': 'ถึง',
      '120': 'รหัสลูกค้า',
      '130': 'Job Code',
      '140': 'รหัสสาเหตุ',
      '150': 'สาเหตุที่ไปทำงาน',
      '160': 'รายละเอียดงานที่ทำ'
    }
  }
}



// WEBPACK FOOTER //
// ./src/assets/labels/hrms6ae.js